<template>
    <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100">
        <!-- Bouton retour placé en haut à gauche -->
        <div class="absolute top-4 left-4">
            <router-link to="/">
                <button type="button"
                    class="bg-primary-dark text-white py-2 px-6 rounded transition duration-300 hover:bg-primary">
                    ← Retour
                </button>
            </router-link>
        </div>

        <form @submit.prevent="login" class="bg-white p-6 rounded shadow-md w-80">
            <h2 class="text-2xl font-bold mb-4">Connexion</h2>

            <div class="mb-4">
                <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
                <input v-model="email" id="email" type="email" class="mt-1 w-full px-3 py-2 border rounded" required />
            </div>

            <div class="mb-4">
                <label for="password" class="block text-sm font-medium text-gray-700">Mot de passe</label>
                <input v-model="password" id="password" type="password" class="mt-1 w-full px-3 py-2 border rounded"
                    required />
            </div>

            <button type="submit"
                class="w-full bg-primary text-white py-2 rounded transition duration-300 hover:bg-primary-dark ">
                Se connecter
            </button>

            <router-link to="/register"> <button type="button"
                    class="w-full my-1 bg-primary text-white py-2 rounded transition duration-300 hover:bg-primary-dark ">
                    Créer un compte
                </button>
            </router-link>

            <p v-if="error" class="text-red-500 mt-2">{{ error }}</p>
        </form>
    </div>
</template>

<script>

const baseUrl = process.env.VUE_APP_BASE_URL

export default {
    data() {
        return {
            email: '',
            password: '',
            error: null,
        };
    },
    methods: {
        async login() {
            this.error = null;

            if (!this.email.trim() || !this.password.trim()) {
                this.error = 'Veuillez remplir tous les champs.';
                return;
            }

            try {
                const response = await fetch(`${baseUrl}/api/users/login`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        email: this.email.trim(),
                        password: this.password.trim(),
                    }),
                });

                const data = await response.json();

                if (!response.ok) {
                    this.error = data.error || data.message || 'Erreur lors de la connexion.';
                    return;
                }

                if (data.token) {
                    localStorage.setItem('token', data.token);
                    this.$store.dispatch('login', { user: data.user, token: data.token });
                    this.$router.push('/dashboard'); // Redirection vers la page dashboard
                }
            } catch {
                this.error = 'Impossible de se connecter au serveur. Veuillez réessayer.';
            }
        },
    },
};
</script>

<style scoped></style>
